import React from 'react';
import createSVG from './createSVG';

const TickIcon = ({style}) => (
  <path style={style} d="M14.63 1l-9 13.63M1 7.73l4.63 6.9" stroke="#7D7D7D" strokeWidth=".87" fill="none" fillRule="evenodd" strokeLinecap="round"/>
);

export default createSVG(TickIcon);
